import { render, staticRenderFns } from "./UsageLimitCheck.vue?vue&type=template&id=5af4b50c"
import script from "./UsageLimitCheck.vue?vue&type=script&lang=js"
export * from "./UsageLimitCheck.vue?vue&type=script&lang=js"
import style0 from "./UsageLimitCheck.vue?vue&type=style&index=0&id=5af4b50c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports